<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <section>
            <h1 class="pb-5">Video Info</h1>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input name="name" class="w-full" v-model="form.pro_name" />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full mb-10">
                <ArticleEditor
                  v-model="form.pro_shortdesc"
                  :config="{
                    plugins: ['blockcode'],
                    addbarAdd: ['text', 'card'],
                    css: '/article-editor/css/',
                    format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
                    align: {
                      left: 'text-left',
                      center: 'text-center',
                      right: 'text-right',
                      justify: 'text-justify'
                    }
                  }"
                ></ArticleEditor>
                <vs-textarea
                  style="display: none"
                  class="w-full"
                  v-model="form.pro_shortdesc"
                />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Video URL</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="video_url"
                  class="w-full"
                  v-model="form.video_url"
                  placeholder="Paste YouTube video URL here"
                />
              </div>
            </div>
            <!-- <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Internal Remark</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  rows="3"
                  name="int_remark"
                  class="w-full"
                  v-model="form.int_remark"
                />
              </div>
            </div> -->
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Thumbnail Image</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <!-- <vs-input
                  type="file"
                  ref="poster"
                  name="poster"
                  class="w-full"
                  v-model="file.poster"
                  @change="setPoster"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('poster')"
                  >{{ errors.first("poster") }}</span
                > -->
                <div v-if="file.poster">
                  <img
                    :src="posterImg"
                    :width="imageWidth"
                    :height="imageHeight"
                  />
                </div>
                <div
                  v-else
                  class="default-upload"
                  style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
                >
                  <vs-button
                    style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                    color="dark"
                    type="border"
                    @click="chooseImage()"
                  >
                    <span>Upload</span>
                  </vs-button>
                </div>
                <div
                  class="grid-button-upload"
                  style="margin-top: 8px;display: grid;grid-template-columns: repeat(2, min-content);grid-gap: 10px;"
                >
                  <!-- secondary / border  >> btn-->
                  <vs-button
                    v-if="file.poster"
                    color="dark"
                    type="border"
                    icon="autorenew"
                    style="display: flex"
                    @click="chooseImage()"
                  >
                    <span>Change</span>
                  </vs-button>
                  <input
                    id="file-upload-img"
                    class="d-none"
                    @change="onUploadImages()"
                    type="file"
                    ref="fileImage"
                    :accept="acceptFile"
                  />
                  <vs-button
                    v-if="file.poster"
                    color="dark"
                    type="border"
                    icon="delete_forever"
                    style="display: flex"
                    @click="popupActivo = true"
                  >
                    Remove
                  </vs-button>
                  <vs-popup
                    classContent="popup-confirm"
                    title="Confirm Delete"
                    :active.sync="popupActivo"
                  >
                    <div>Are you sure you want to delete the image?</div>
                    <div class="wrap-button">
                      <vs-button
                        color="dark"
                        type="border"
                        style="font-size: 12px !important;"
                        @click="popupActivo = false"
                      >
                        No
                      </vs-button>
                      <vs-button
                        color="primary"
                        style="font-size: 12px !important;"
                        @click="removeposter"
                      >
                        Yes
                      </vs-button>
                    </div>
                  </vs-popup>
                </div>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Publish Date & Time</span>
                <div style="font-size: 0.75rem; color: #aaa">
                  Leave Start blank to publish immediately and End blank to keep
                  the video available indefinitely
                </div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <div class="vx-row align-items-center">
                  <div>
                    <el-date-picker
                      v-model="form.daterange[0]"
                      type="datetime"
                      style="width: 100%"
                      placeholder="Start"
                      value-format="yyyy-MM-dd HH:mm"
                      format="dd-MM-yyyy HH:mm"
                    >
                    </el-date-picker>
                  </div>
                  <div class="px-4">-</div>
                  <div>
                    <el-date-picker
                      v-model="form.daterange[1]"
                      type="datetime"
                      style="width: 100%"
                      placeholder="End"
                      value-format="yyyy-MM-dd HH:mm"
                      format="dd-MM-yyyy HH:mm"
                    >
                    </el-date-picker>
                  </div>
                </div>
                <!-- <span class="text-danger text-sm" v-show="errors.has('daterange')">
                  {{ splitError(errors.first("daterange"), "daterange") }}
                </span> -->
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Listing Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Publish Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Listing Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Publish Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      vs-value="1"
                      >Yes</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      vs-value="0"
                      >No</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
          </section>
          <hr />
          <!-- Related Items Card -->
          <section>
            <template>
              <section>
                <h1 class="py-5 card-title">Related Items</h1>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Related Videos</span>
                    <div style="font-size: 0.75rem; color: #aaa">
                      These videos will be recommended when viewing the video
                    </div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <div>
                      <!-- <v-select
                  v-model="related_video_ids_input"
                  :options="related_video_ids_options"
                  multiple
                ></v-select> -->
                      <v-select
                        class="hide-select-action"
                        v-model="related_video_ids_search"
                        :options="relatedEventSearchOptions"
                        @input="onAddEventRelated"
                        placeholder="Search Video"
                      ></v-select>
                      <div class="px-1 mt-4">
                        <draggable
                          v-model="related_video_ids_input"
                          tag="div"
                          class="row"
                        >
                          <div
                            class="col col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2 cursor-move"
                            v-for="(item, index) in related_video_ids_input"
                            :key="index"
                          >
                            <vs-card class="position-relative">
                              <div
                                class="close-btn"
                                @click="removeRelatedEvent(item.value)"
                              >
                                <i class="fas fa-times-circle"></i>
                              </div>
                              <div class="">
                                <img
                                  :src="item.poster"
                                  class="img-fluid"
                                  alt=""
                                />
                              </div>
                              <div class="mt-2 overflow-hidden card-label">
                                {{ item.label }}
                              </div>
                            </vs-card>
                          </div>
                        </draggable>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Related Products</span>
                    <div style="font-size: 0.75rem; color: #aaa">
                      These products will be recommended when viewing the event
                    </div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <v-select
                      class="hide-select-action"
                      v-model="related_product_ids_search"
                      :options="relatedProductSearchOptions"
                      @input="onAddProductRelated"
                      placeholder="Search Product"
                    ></v-select>
                    <div class="px-1 mt-2">
                      <draggable
                        v-model="related_product_ids_input"
                        tag="div"
                        class="row"
                      >
                        <div
                          class="col col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2 cursor-move"
                          v-for="(item, index) in related_product_ids_input"
                          :key="index"
                        >
                          <vs-card class="position-relative">
                            <div
                              class="close-btn"
                              @click="removeRelatedProduct(item.value)"
                            >
                              <i class="fas fa-times-circle"></i>
                            </div>
                            <div class="">
                              <img
                                :src="item.poster"
                                class="img-fluid"
                                alt=""
                              />
                            </div>
                            <div class="mt-2 overflow-hidden card-label">
                              {{ item.label }}
                            </div>
                          </vs-card>
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
                <!-- <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Keywords</span>
                    <div style="font-size: 0.75rem; color: #aaa"></div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <v-select
                      v-model="keywords_input"
                      multiple
                      taggable
                      :options="['']"
                    ></v-select>
                  </div>
                </div> -->
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Speakers</span>
                    <div style="font-size: 0.75rem; color: #aaa">
                      These speakers will be recommended when viewing the
                      speaker
                    </div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <v-select
                      class="hide-select-action"
                      v-model="speakers_search"
                      :options="speakers_select_options"
                      @input="onAddSpeaker"
                      placeholder="Search Speaker"
                    ></v-select>
                    <div class="px-1 mt-2">
                      <draggable v-model="speakers" tag="div" class="row">
                        <div
                          class="col col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2 cursor-move"
                          v-for="(item, index) in speakers"
                          :key="index"
                        >
                          <vs-card class="position-relative">
                            <div
                              class="close-btn"
                              @click="removeSpeaker(item.value)"
                            >
                              <i class="fas fa-times-circle"></i>
                            </div>
                            <div class="">
                              <img
                                :src="item.poster"
                                class="img-fluid"
                                alt=""
                              />
                            </div>
                            <div class="mt-2 overflow-hidden card-label">
                              {{ item.label }}
                            </div>
                          </vs-card>
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Tags</span>
                    <div style="font-size: 0.75rem; color: #aaa">
                      Use tags to link related content together for better
                      recommendations
                    </div>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <v-select
                      v-model="tags"
                      multiple
                      taggable
                      :options="tag_select_options"
                      placeholder="Add or Search Tag"
                      :filter="customTagFilter"
                      @input="onTagInput"
                    ></v-select>
                  </div>
                </div>
              </section>
            </template>
          </section>

          <hr />
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Create Video</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";

import Service from "@/services";

import moment from "moment";
import { mapState } from "vuex";
import { timezones } from "@/utils/Timezones";

import vSelect from "vue-select";
import draggable from "vuedraggable";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ArticleEditor from "@/components/ArticleEditor.vue";
const short = require("short-uuid");
const translator = short();

const dict = {
  form: {
    name: {
      required: "Please enter an event name"
    },
    slug: {
      required: "Please enter your last name",
      alpha: "Your last name may only contain alphabetic characters"
    }
  }
};

// register custom messages
Validator.localize("en", dict);

export default {
  components: { flatPickr, ArticleEditor, vSelect, draggable },
  data: () => ({
    isClone: false,
    timezones: timezones,
    suffixParams: "",
    valid: true,
    editorOption: {
      modules: {
        toolbar: "#toolbar"
      }
    },
    editor2Option: {
      modules: {
        toolbar: "#toolbar-2"
      }
    },
    parent_id: null,
    form: {
      s: null,
      e: null,
      target: "merchant",
      pro_name: "",
      poster: "",
      slug: "",
      pro_shortdesc: "",
      video_url: "",
      keywords: "",
      related_product_ids: "",
      related_video_ids: "",
      daterange: ["", ""],
      publish_status: 1,
      listing_status: 1
    },
    live_engine: "ivs",
    viewer_endpoint_url: "",
    concurrentList: [
      { value: 0, text: "Unlimited" },
      { value: 1, text: "1" },
      { value: 2, text: "2" },
      { value: 3, text: "3" },
      { value: 4, text: "4" },
      { value: 5, text: "5" }
    ],
    currencyForm: {
      currency: "THB",
      hasReference: false,
      altcurrencycode: "USD",
      altcurrencyrate: null
    },
    ticketForm: {
      title: "Video Ticket",
      slug: "video-event-ticket",
      shortdesc: "",
      price: 0,
      fullprice: 0,
      selldaterange: [
        moment().format("YYYY-MM-DD HH:mm"),
        moment().format("YYYY-MM-DD HH:mm")
      ],
      ticket_note: "",
      qty: null,
      requiredqty: null,
      minqty: null,
      maxqty: null,
      publish_status: 1,
      weight: 0
    },
    disableZoomToggle: false,
    datetime: null,
    configFromdateTimePicker: {
      minDate: new Date(),
      maxDate: null,
      dateFormat: "d-m-Y H:i",
      enableTime: true,
      enableSeconds: false
    },
    configTodateTimePicker: {
      minDate: null,
      maxDate: null,
      dateFormat: "d-m-Y H:i",
      enableTime: true,
      enableSeconds: false
    },
    file: {
      poster: null
    },
    products: [],
    videoList: [],
    related_product_ids_options: [],
    related_video_ids_options: [],
    related_product_ids_search: "",
    related_product_ids_input: [],
    related_video_ids_search: "",
    related_video_ids_input: [],
    keywords_input: [],
    is_event_loaded: false,
    tags: [],
    tags_options: [],
    speakers: [],
    speakers_search: "",
    speakers_options: [],
    acceptFile: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
    popupActivo: false,
    posterImg: null,
    imageWidth: 0,
    imageHeight: 0
  }),
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    }),
    relatedEventSearchOptions() {
      return this.related_video_ids_options.filter(
        item => !this.related_video_ids_input.find(ip => ip.value == item.value)
      );
    },
    relatedProductSearchOptions() {
      return this.related_product_ids_options.filter(
        item =>
          !this.related_product_ids_input.find(ip => ip.value == item.value)
      );
    },
    tag_select_options() {
      return this.tags_options.map(item => item.tag);
    },
    speakers_select_options() {
      return this.speakers_options
        .filter(
          item => !this.speakers.find(ip => ip.speaker_id == item.speaker_id)
        )
        .map(item => {
          const mapped_item = {
            label: item.pro_name,
            value: item.speaker_id,
            item: item,
            poster: item.poster
          };
          return mapped_item;
        });
    }
  },
  created() {
    this.$vs.loading();
    this.loadTag();
    this.loadSpeakers();
    /*
    console.log(new Date());
    console.log(moment().unix());
    */

    // this.timezones = Object.keys(this.timezones).map(item => {
    //   return { key: item, value: item };
    // });
    setTimeout(() => {
      if (this.e) {
        let data = {
          e: this.e,
          s: this.s,
          perPage: 999
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        Service.Product.getsInSeller(params).then(res => {
          this.products = res.data.rows;
          this.products.sort(this.compareValues("weight", "desc"));
        });

        let dataMyVideo = {
          e: this.e,
          s: this.s,
          target: "merchant",
          perPage: 999,
          currentPage: 1
        };

        let paramsMyVideo = Object.keys(dataMyVideo)
          .map(key => key + "=" + dataMyVideo[key])
          .join("&");

        Service.Video.gets(paramsMyVideo)
          .then(res2 => {
            this.videoList = res2.data.rows;
          })
          .catch(error => {
            console.log(error);
          });
        // Service.Event.get(this.e)
        //   .then(res => {
        //     this.parent_id = res.data.event.event_id;
        //     this.form.timezone = res.data.event.timezone;

        //     this.configFromdateTimePicker.minDate =
        //       moment(res.data.event.datetime, "YYYY-MM-DD HH:mm")
        //         .subtract(100, "days")
        //         .unix() * 1000;

        //     this.configFromdateTimePicker.maxDate =
        //       moment(res.data.event.datetime_end, "YYYY-MM-DD HH:mm")
        //         .add(100, "days")
        //         .unix() * 1000;

        //     this.configTodateTimePicker.minDate =
        //       moment(res.data.event.datetime, "YYYY-MM-DD HH:mm")
        //         .subtract(100, "days")
        //         .unix() * 1000;

        //     this.configTodateTimePicker.maxDate =
        //       moment(res.data.event.datetime_end, "YYYY-MM-DD HH:mm")
        //         .add(100, "days")
        //         .unix() * 1000;
        //   })
        //   .catch(e => {
        //     console.log(e);
        //     /* this.$router.push("/pages/error-404").catch(() => {}); */
        //   });
      }

      this.$vs.loading.close();
      // this.form.s = this.s;
    }, 1500);
  },
  watch: {
    // live_engine: function(newVal) {
    //   if (newVal == "zoom") {
    //     this.form.zoom_status = 1;
    //     this.disableZoomToggle = false;
    //   } else {
    //     this.form.zoom_status = 0;
    //     this.disableZoomToggle = true;
    //   }
    // },
    "form.pro_name": function(newVal) {
      var slugify = require("slugify");
      this.form.slug = slugify(newVal, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false // strip special characters except replacement, defaults to `false`
      });

      if (this.form.slug.match(/(\w+)/g).length > 5) {
        var words = this.form.slug.split("-");
        this.form.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    },
    "form.slug": function(newVal) {
      var slugify = require("slugify");
      this.form.slug = slugify(newVal, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false // strip special characters except replacement, defaults to `false`
      });

      if (this.form.slug.match(/(\w+)/g).length > 5) {
        var words = this.form.slug.split("-");
        this.form.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    },
    products(val) {
      this.related_product_ids_options = val.map(item => {
        const mapped_item = {
          label: item.pro_title,
          value: item.product_id,
          item: item,
          poster: item.poster
        };
        return mapped_item;
      });
      // this.related_product_ids_input = this.basicForm.related_product_ids
      //   ? this.basicForm.related_product_ids
      //       .split(",")
      //       .map(item =>
      //         this.related_product_ids_options.find(ep => ep.value == item)
      //       )
      //       .filter(item => !!item)
      //   : [];
    },
    videoList(val) {
      this.related_video_ids_options = val.map(item => {
        const mapped_item = {
          label: item.pro_name,
          value: item.video_id,
          e: item.slug,
          poster: item.poster
        };
        return mapped_item;
      });
      this.is_event_loaded = true;
      // setTimeout(() => {
      //   this.related_video_ids_input = this.basicForm.related_video_ids
      //     ? this.basicForm.related_video_ids
      //         .split(",")
      //         .map(item =>
      //           this.related_video_ids_options.find(ep => {
      //             return ep.value == item;
      //           })
      //         )
      //         .filter(item => !!item)
      //     : [];
      // }, 300);
    }
  },
  mounted() {
    setTimeout(() => {
      this.suffixParams = "?s=" + this.s + "&e=" + this.e;
    }, 1000);
    this.setImageSize();
  },
  methods: {
    customTagFilter(option, search) {
      if (!search) return option;
      return option.filter(label=>label.toString().toLowerCase().includes(search.toLowerCase()));
    },
    onTagInput(newTags) {
      // Normalize newTags to avoid case-sensitive duplicates
      const normalizedTags = [];

      newTags.forEach(tag => {
        const lowerCaseTag = tag.toLowerCase();
        const existingTag = this.tag_select_options.find(
          option => option.toLowerCase() === lowerCaseTag
        );

        if (existingTag) {
          // Use the existing tag
          if (!normalizedTags.includes(existingTag)) {
            normalizedTags.push(existingTag);
          }
        } else {
          // Add the new tag both to the tags list and tag_select_options
          if (!normalizedTags.includes(tag)) {
            this.tag_select_options.push(tag);
            normalizedTags.push(tag);
          }
        }
      });

      // Update the tags without duplicates
      this.tags = normalizedTags;
    },
    setImageSize() {
      let posterimage = document.querySelector("img");
      let w = posterimage.naturalWidth;
      let h = posterimage.naturalHeight;
      this.imageHeight = h;
      this.imageWidth = w;

      if (w > h) {
        this.imageWidth = 300;
        this.imageHeight = "auto";
      } else {
        this.imageHeight = 300;
        this.imageWidth = "auto";
      }
    },
    chooseImage() {
      document.getElementById("file-upload-img").click();
    },
    onUploadImages() {
      // this.basicForm.poster = this.$refs.fileImage.files[0]
      this.file.poster = this.$refs.fileImage.files[0];
      const reader = new FileReader();
      reader.onloadend = async () => {
        this.posterImg = reader.result;

        // var str = reader.result.split(',')[1]
        // var image = this.b64toBlob(str, "image/jpeg")
        // var imgURL = URL.createObjectURL(image)
        // this.posterUpdate = imgURL
        // this.basicForm.poster = reader.result
      };
      reader.readAsDataURL(this.$refs.fileImage.files[0]);
      this.$refs.fileImage.value = null;
      // this.uploadPoster(this.$refs.fileImage.files[0]);
    },
    removeposter() {
      this.file.poster = null;
      this.file.posterImg = null;
    },
    async loadTag() {
      let filterData = {
        e: this.e,
        s: this.s
      };

      let params = Object.keys(filterData)
        .map(key => key + "=" + filterData[key])
        .join("&");

      const res = await Service.Tags.gets(params);
      this.tags_options = res.data.tags;
      return res.data.tags;
    },
    async loadSpeakers() {
      let dataMySpeaker = {
        e: this.e,
        s: this.s,
        target: "merchant",
        perPage: 999,
        currentPage: 1
      };

      let paramsMySpeaker = Object.keys(dataMySpeaker)
        .map(key => key + "=" + dataMySpeaker[key])
        .join("&");

      Service.Speakers.gets(paramsMySpeaker)
        .then(res2 => {
          this.speakers_options = res2.data.rows;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async createTags(tags) {
      let params = {
        e: this.e,
        s: this.s,
        tags: tags
      };

      const res = await Service.Tags.create(params);
      return res.data.tags;
    },
    compareValues(key, order = "asc") {
      return function(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
      };
    },
    onAddEventRelated() {
      if (!this.related_video_ids_search) {
        return;
      }
      this.related_video_ids_input.push({
        label: this.related_video_ids_search.label,
        value: this.related_video_ids_search.value,
        e: this.related_video_ids_search.e,
        poster: this.related_video_ids_search.poster
      });
      this.related_video_ids_search = "";
    },
    onAddProductRelated() {
      if (!this.related_product_ids_search) {
        return;
      }
      this.related_product_ids_input.push({
        label: this.related_product_ids_search.label,
        value: this.related_product_ids_search.value,
        item: this.related_product_ids_search,
        poster: this.related_product_ids_search.poster
      });
      this.related_product_ids_search = "";
    },
    removeRelatedEvent(id) {
      this.related_video_ids_input = this.related_video_ids_input.filter(
        item => item.value != id
      );
    },
    removeRelatedProduct(id) {
      this.related_product_ids_input = this.related_product_ids_input.filter(
        item => item.value != id
      );
    },
    onAddSpeaker() {
      if (!this.speakers_search) {
        return;
      }
      this.speakers.push({
        label: this.speakers_search.label,
        value: this.speakers_search.value,
        item: this.speakers_search,
        poster: this.speakers_search.poster
      });
      this.speakers_search = "";
    },
    removeSpeaker(id) {
      this.speakers = this.speakers.filter(item => item.value != id);
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          Service.Event.search(this.form.slug).then(res => {
            if (res.data.results.length > 0) {
              this.$vs.notify({
                title: "Oops!",
                text: "ERROR : This slug already used by others.",
                color: "danger",
                fixed: true
              });
              return;
            } else {
              this.submit();
            }
          });
        }
      });
    },
    validateSlug() {
      this.$vs.loading();
      Service.Event.search(this.form.slug).then(res => {
        if (res.data.results.length > 0) {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : This slug already used by others.",
            color: "danger",
            fixed: true
          });
        }
        this.$vs.loading.close();
      });
    },
    async submit() {
      /*CONVERT DATE FORMAT */
      // this.form.daterange[0] = moment(
      //   this.form.daterange[0],
      //   "DD-MM-YYYY HH:mm"
      // ).format("YYYY-MM-DD HH:mm");
      // this.form.daterange[1] = moment(
      //   this.form.daterange[1],
      //   "DD-MM-YYYY HH:mm"
      // ).format("YYYY-MM-DD HH:mm");

      this.form.slug = translator.new();

      if (this.form.slug.match(/(\w+)/g).length > 5) {
        var words = this.form.slug.split("-");
        this.form.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }

      // this.form = {
      //   ...this.form,
      //   // ...this.currencyForm,
      //   // parent_id: this.parent_id,
      //   // ticket: this.ticketForm,
      //   // mode: "video",
      //   related_product_ids: this.related_product_ids_input
      //     .map(item => item.value)
      //     .join(","),
      //   related_video_ids: this.related_video_ids_input
      //     .map(item => item.value)
      //     .join(","),
      //   keywords: this.keywords_input.join(",")
      // };
      this.form.s = this.s;
      this.form.e = this.e;

      const resTags = await this.loadTag();

      const existedTags = resTags.filter(item =>
        this.tags.find(op => op == item.tag)
      );
      const needToCreatedTags = this.tags.filter(
        item => !resTags.find(op => op.tag == item)
      );
      const createdTags =
        needToCreatedTags && needToCreatedTags.length
          ? await this.createTags(needToCreatedTags)
          : [];
      this.form.related_product_ids = this.related_product_ids_input
        .map(item => item.value)
        .join(",");
      this.form.related_video_ids = this.related_video_ids_input
        .map(item => item.value)
        .join(",");
      // this.form.keywords = this.keywords_input.join(",");
      this.form.tags = [
        ...existedTags.map(item => item.tag_id),
        ...createdTags.map(item => item.tag_id)
      ];

      this.form.publishdate_start = this.form.daterange[0]
        ? moment(this.form.daterange[0]).format("YYYY-MM-DD HH:mm")
        : null;
      this.form.publishdate_end = this.form.daterange[1]
        ? moment(this.form.daterange[1]).format("YYYY-MM-DD HH:mm")
        : null;

      this.form.speakers = this.speakers.map(item => item.value);

      this.form.publish_status = this.form.publish_status;
      this.form.listing_status = this.form.listing_status;

      this.$vs.loading();

      Service.Video.create(this.form)
        .then(async res => {
          if (res.success) {
            //this.$router.push("/conferences/sessions/");
            if (res.success) {
              await this.doUploadFile(res.data.video_id);
              this.$vs.loading.close();
              setTimeout(() => {
                this.$router.push(
                  "/videos/" + res.data.video_id + "/view?" + this.suffixParams
                );
              }, 1000);
            }
          }
        })
        .catch(err => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
        });
    },
    async doUploadFile(video_id) {
      if (this.file.poster != null) {
        this.$vs.loading();
        var formData = new FormData();
        formData.append("e", this.e);
        formData.append("s", this.s);
        formData.append("target", "merchant");
        formData.append("poster", this.file.poster);

        await Service.Video.update(video_id, formData)
          .then(res => {
            // this.form.qty = qty;
            if (res.success) {
              this.$vs.notify({
                title: "Success",
                text: "Update complete.",
                color: "success"
              });
            }
            this.$vs.loading.close();
          })
          .catch(err => {
            this.$vs.notify({
              title: "Oops!",
              text: "ERROR : " + err.error,
              color: "danger"
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          title: "Success",
          text: "Update complete.",
          color: "success"
        });
      }
    },
    async doCreateVideo(id) {
      let data = { e: this.e };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      this.$vs.loading();
      Service.Event.createVideo(params, {
        object_id: id,
        live_engine: this.live_engine,
        viewer_endpoint_url: this.viewer_endpoint_url
      })
        .then(res => {
          return res;
        })
        .catch(e => {
          return e;
        });
    },
    setPoster(e) {
      this.file.poster = e.target.files[0];
    },
    onEditorBlur(quill) {
      //console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      //console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      //console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      //console.log("editor change!", quill, html, text);
      //this.content = html;
    },
    onFromChange(selectedDates, dateStr, instance) {
      //et min = moment(dateStr, "DD-MM-YYYY HH:mm").unix() * 1000;
      //this.$set(this.configTodateTimePicker, "minDate", min);
    },
    onToChange(selectedDates, dateStr, instance) {
      //let max = moment(dateStr, "DD-MM-YYYY HH:mm").unix() * 1000;
      //this.$set(this.configFromdateTimePicker, "maxDate", max);
    }
  }
};
</script>
<style>
.editor {
  height: 10rem;
  margin-bottom: 0px;
}
</style>
<style>
.hide-select-action .vs__actions {
  display: none;
}
.close-btn {
  font-size: 24px;
  position: absolute;
  right: -12px;
  top: -12px;
  cursor: pointer;
}
</style>
